import { CSSProperties, ChangeEvent } from 'react';
import { Wrapper, StyledInput } from './AddFileButton.style';

import { ReactComponent as AddFileIcon } from 'assets/icons/addFile.svg';
import { useAppSelector } from 'store/hooks';
import { selecZoom } from 'store/features/zoom/zoomSlice';

const AddFileButton = ({
    onChange,
    styles
}: {
    onChange: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
    styles?: CSSProperties;
}) => {
    const zoom = useAppSelector(selecZoom);

    return (
        <Wrapper style={{ order: Number.MAX_SAFE_INTEGER, ...styles }} zoom={zoom}>
            <StyledInput htmlFor='addFile'>
                <AddFileIcon />
                Dodaj plik
                <input
                    type='file'
                    id='addFile'
                    name='addFile'
                    onChange={onChange}
                    multiple
                    accept='.png, .jpg, .jpeg, .bmp, .tif, .tiff, .gif, .pdf'
                />
            </StyledInput>
        </Wrapper>
    );
};

export default AddFileButton;
